import React, { useEffect, useState } from "react";
import settings from "../assets/img/HumQadamHome/settings.svg";
import about from "../assets/img/HumQadamHome/aboutus.svg";
import { useDispatch, useSelector } from "react-redux";
import { changeTab } from "../redux/TabSlice";
import { toast } from "react-toastify";
import { setBackFromSettings } from "../redux/PageSlice";
import ModalSettings from "./ModalSettings";
import { FeedbackIcon, PhoneIcon } from "./ContactFeedbackIcons";

function Options({ handleOpen, hideSettings = false }) {
  const { district, selDistrictId } = useSelector((state) => state.district);
  const { province, selProvinceId } = useSelector((state) => state.province);
  const [openAbout, setOpenAbout] = useState(false);
  const { tab } = useSelector((state) => state.tab);
  const [pro, setPro] = useState();
  const [dis, setDis] = useState();
  const dispatch = useDispatch();

  const handleClose = () => {
    if (!selDistrictId) {
      toast.error("Select District");
      return;
    }
    setOpenAbout(false);
  };

  useEffect(() => {
    if (!district?.length) {
      setDis(null);
      return;
    }
    const match = district.find((d) => d._id === selDistrictId);
    setDis(match ?? null);
  }, [selDistrictId, district]);

  useEffect(() => {
    if (!province?.length) {
      setPro(null);
      return;
    }
    const match = province.find((p) => p._id === selProvinceId);
    setPro(match ?? null);
  }, [selProvinceId, province]);

  const handleClick = (tabS) => {
    if (!selDistrictId) {
      toast.error("Select District");
      return;
    }
    dispatch(setBackFromSettings(tab));
    dispatch(changeTab(tabS));
  };
  const handleAbout = () => {
    if (!selDistrictId) {
      toast.error("Select District");
      return;
    }
    handleOpen();
  };
  return (
    <div className="flex flex-col items-end justify-end mt-2">
      <div className="flex m-2">
        <img
          onClick={() => handleAbout()}
          className="px-2 w-11 cursor-pointer"
          alt="About"
          src={about}
        />
        <div 
          onClick={() => handleClick("ContactInfo")} 
          title="Contact Us"
          className="px-2 cursor-pointer flex items-center"
        >
          <PhoneIcon />
        </div>
        <div 
          onClick={() => handleClick("Feedback")} 
          title="Feedback"
          className="px-2 cursor-pointer flex items-center"
        >
          <FeedbackIcon />
        </div>
        <div onClick={() => handleClick("Settings")} className={hideSettings ? "hidden" : undefined}>
          <img
            className="px-2 w-11 cursor-pointer"
            alt="Settings"
            src={settings}
          />
        </div>
      </div>
      <div
        onClick={() => setOpenAbout(true)}
        className="cursor-pointer underline flex mx-2 mr-5"
      >
        <p>
          {dis?.name?.text || dis?.name}, {pro?.name?.text || pro?.name}
        </p>
      </div>
      <ModalSettings open={openAbout} handleClose={handleClose} />
    </div>
  );
}

export default Options;
